import { PAGES } from '../constants/PagesConstants';
import { ProfilePageInterface } from '../types/ProfilePageInterface';

export type CustomPageTemplate = 'text' | 'cover-photo' | 'sections';

export const CUSTOM_PAGE_TEMPLATES: CustomPageTemplate[] = ['cover-photo', 'sections', 'text'];

export const isCustomPageTemplate = (value: string | undefined): value is CustomPageTemplate =>
  CUSTOM_PAGE_TEMPLATES.includes(value as CustomPageTemplate);

const BUILT_IN_PAGE_NAMES = ['About_Page', 'Press_Page'];


export const customPageKey = (title: string): string => title.trim().toLowerCase();

export const customPageUrlPath = (title: string): string =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const isBuiltInPageKey = (title: string): boolean =>
  PAGES.some((page) => page.key === customPageKey(title) || page.label.toLowerCase() === customPageKey(title));

export const isCustomPage = (page: Pick<ProfilePageInterface, 'name' | 'navLink'>): boolean =>
  !BUILT_IN_PAGE_NAMES.includes(page.name) && !!page.navLink?.trim() && !isBuiltInPageKey(page.navLink);

export const customPageTemplateOf = (page: Pick<ProfilePageInterface, 'profileSections'>): CustomPageTemplate => {
  const templates = page.profileSections.map((section) => section.template);
  if (templates.includes('media_copy')) return 'sections';
  if (templates.includes('media_gallery')) return 'cover-photo';
  return 'text';
};
